export default "__VITE_ASSET__Bw3g9pQq__"